module.exports = __webpack_public_path__ + "img/logo.f352cbab.svg";